import React from 'react';
import { useEffect } from "react";
import Modal from 'react-bootstrap/Modal';
// import { useGoogleLogin } from '@react-oauth/google';

const LoginOptionsPopup = ( props ) =>
{

  useEffect( () =>
  {
    if( window.google && window.google.accounts && window.google.accounts.id )
    {
      // console.log( "Calling to initialise google accounts...", "CLIENT ID ", process.env.REACT_APP_GOOGLE_CLIENT_ID );
      // console.log( "current ", window.location.href )

      window.google.accounts.id.initialize( {
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        callback: ( response ) =>
        {
          props.onGoogleLogin( response );
        }
      } );

      // Render the Google button
      window.google.accounts.id.renderButton(
        document.getElementById( "googleSignInDiv" ),
        {
          theme: "outline",
          size: "large",
          text: "signin_with", // or "continue_with"
          shape: "rectangular"
        }
      );
    }
  }, [] );

  // const onGoogleLoginClicked = () =>
  // {
  //   window.google.accounts.id.prompt(); // Show One Tap OR redirect
  // };

  return (

    <Modal
      show={ true }
      onHide={ props.close }
      centered
      className="modal-popup"
    >
      <Modal.Header closeButton>
        <Modal.Title className="modal-popup-title">Login</Modal.Title>
      </Modal.Header>

      <Modal.Body className="login-popup-modal-body">

        <div className="login-popup-modal-body-primary-content">
          <div className="login-popup-reasons-text" >
            <p><b>One account, every device – </b>Continue where you left off, anytime.</p>
            <p><b>Your name, your way – </b>Pick a clean, unique username you'll love.</p>
          </div>

          <div className="login-popup-login-buttons" >

            {/* <div
              className="login-popup-social-login-button login-popup-social-login-button-google"
              onClick={ () => { onGoogleLoginClicked(); } }>
              <img src={ process.env.PUBLIC_URL + '/ui/social-icon-google.png' } alt="Google icon" />
              Login with Google
            </div> */}

            <div id="googleSignInDiv"></div>

            {/* <div
              className="login-popup-social-login-button login-popup-social-login-button-discord"
              onClick={ () => { console.log( "Discord Login BUtton" ); } }>
              <img src={ process.env.PUBLIC_URL + '/ui/social-icon-discord-white.png' } alt="Discord icon" />
              Login with Discord
            </div> */}
          </div>
        </div>


        <div className="login-popup-footnote-text" style={ { display: 'flex', justifyContent: 'center', width: '100%' } }>
          <p>
            By signing in with an account, you are agreeing to our{ ' ' }
            <a href="/terms" target="_blank" rel="noopener noreferrer">Terms</a>{ ' ' }
            and{ ' ' }
            <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>{ ' ' }
            and to receive emails about key TileFolk.io updates (you can unsubscribe at any time).
          </p>
        </div>

      </Modal.Body>
    </Modal>
  );
}

export default LoginOptionsPopup;
